"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFormFieldController = void 0;
var APFormFieldController = /** @class */ (function () {
    function APFormFieldController() {
    }
    APFormFieldController.prototype.getText = function () {
        return this.text;
    };
    APFormFieldController.prototype.setText = function (text) {
        this.text = text;
        if (this.onChange)
            this.onChange();
    };
    return APFormFieldController;
}());
exports.APFormFieldController = APFormFieldController;
